import { render, staticRenderFns } from "./TermAccept.vue?vue&type=template&id=c9f31d12"
import script from "./TermAccept.vue?vue&type=script&lang=js"
export * from "./TermAccept.vue?vue&type=script&lang=js"
import style0 from "./TermAccept.vue?vue&type=style&index=0&id=c9f31d12&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports